import graphqlClient from "@/GQLClient";
import {
  type InstitutionBasic,
  type InstitutionMinimal,
} from "@/extendedTypes";
import {
  GetAllInstitutionsDocument,
  InstitutionQueryDocument,
} from "@/graphql/generated-types";

const getInstitution = async (id: string) => {
  try {
    const response = await graphqlClient.query({
      query: InstitutionQueryDocument,
      variables: {
        ids: [id],
      },
    });

    if (!response.data?.institutions?.get) {
      throw new Error("An error ocurred when getting institution data");
    }

    return response.data.institutions.get[0] as InstitutionBasic;
  } catch (error) {
    console.error("getInstitution error", error);
  }
};

const getAllInstitutions = async () => {
  try {
    const response = await graphqlClient.query({
      query: GetAllInstitutionsDocument,
    });

    if (!response.data?.institutions?.get) {
      throw new Error("An error occurred when getting institution data");
    }

    return response.data.institutions.get as InstitutionMinimal[];
  } catch (error) {
    console.error("getAllInstitutions error", error);
  }
};

export default {
  getInstitution,
  getAllInstitutions,
};
